import config from 'config/app.config'
import { openErrorToaster } from './toaster.helpers'
import CryptoJS from 'crypto-js'

export const decryptData = (encryptedData, iv) => {
  const ENCRYPTION_KEY = config.API_ENCRYPTION_KEY
  if (!ENCRYPTION_KEY || ENCRYPTION_KEY.length !== 64) {
    openErrorToaster({ message: 'Something went wrong!!!' })
    return
  }

  try {
    // Convert key and IV from hex to WordArray
    const key = CryptoJS.enc.Hex.parse(ENCRYPTION_KEY)
    const ivWordArray = CryptoJS.enc.Hex.parse(iv)

    // Decrypt data
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: CryptoJS.enc.Hex.parse(encryptedData) },
      key,
      { mode: CryptoJS.mode.CBC, iv: ivWordArray, padding: CryptoJS.pad.Pkcs7 }
    )

    // Convert decrypted data to string
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8)
    return JSON.parse(decryptedText)?.data
  } catch (error) {
    console.error('Decryption Error:', error)
    throw new Error('Failed to decrypt data')
  }
}

export default decryptData
